<ng-container *ngIf="orders$ | async as orders">
  <table mdbTable *ngIf="orders.length != 0">
    <thead>
      <tr>
        <th class="table_heading1" scope="col">
          Purchase Date
        </th>
        <th class="table_heading1 no_mobile" scope="col" *ngIf="isAdmin">
          City
        </th>
        <th class="table_heading1 no_mobile" scope="col" *ngIf="isAdmin">
          Venue
        </th>
        <th class="table_heading1 no_mobile" scope="col">
          Type
        </th>
        <th class="table_heading1" scope="col">
          Pass Name
        </th>
        <th class="table_heading1 no_mobile" scope="col">
          Event Date
        </th>
        <th class="table_heading1" scope="col">
          Customer
        </th>
        <th class="table_heading1 no_mobile" scope="col">
          Email
        </th>
        <th class="table_heading1 no_mobile" scope="col">
          Units
        </th>
        <th class="table_heading1" scope="col">
          Total
        </th>
        <th class="table_heading1 no_mobile" scope="col">
          Redeem Date
        </th>
        <th class="table_heading1" scope="col">
          <span class="no_mobile"> Redeemed</span>
        </th>
      </tr>
    </thead>
    <tbody class="body1">
      <ng-container *ngFor="let order of filter(orders); let i = index">
        <tr *ngIf="show(i)">
          <td scope="row">
            {{ order.summary.purchasedAt | date: "MM/dd/yy" }} <br />
            {{ order.summary.purchasedAt | date: "HH:mm a" }}
          </td>
          <td class="no_mobile" *ngIf="isAdmin">
            {{ order.city.name + ", " + order.city.state }}
          </td>
          <td class="no_mobile" *ngIf="isAdmin">
            {{ order.venue.name }}
          </td>
          <td class="no_mobile">
            {{ getType(order.product.type) }}
          </td>
          <td>
            {{ order.product.name }}
          </td>
          <td class="no_mobile">
            {{ order.event.date | date: "MM/dd/yy" }}
          </td>
          <td>
            {{ order.user.name }}
          </td>
          <td class="no_mobile">
            <div *ngIf="!isAdmin">{{ mask(order.user.email) }}</div>
            <a
              id="email_text"
              *ngIf="isAdmin"
              [href]="mailTo(order.user.email)"
              >{{ order.user.email }}</a
            >
          </td>
          <td class="no_mobile" style="text-align: center;">
            {{ order.summary.units }}
          </td>
          <td>{{ order.summary.total | currency }}</td>
          <td *ngIf="order.summary.redeemedAt == null" class="no_mobile">
            Not Redeemed
          </td>
          <td class="no_mobile" *ngIf="order.summary.redeemedAt != null">
            {{ order.summary.redeemedAt | date: "MM/dd/yy HH:mm" }}
          </td>
          <td
            *ngIf="order.summary.redeemedAt == null"
            class="not-redeemed"
            style="text-align: center;"
          >
            <img
              height="16px"
              src="../../../../../assets/icons/circle.svg"
              class="clickable"
              (click)="redeem(order)"
              style="justify-items: center;"
            />
          </td>
          <td
            *ngIf="order.summary.redeemedAt != null"
            class="redeemed"
            style="text-align: center;"
          >
            <img
              height="16px"
              src="../../../../../assets/icons/check-circle.svg"
              class="clickable"
              (click)="redeem(order)"
            />
          </td>
        </tr>
      </ng-container>
    </tbody>
    <div class="container" style="height:5px;"></div>
  </table>
  <div
    class="d-flex flex-row no-gutters  align-items-center"
    *ngIf="orders.length != 0"
  >
    <div class="chip dropup" mdbDropdown>
      <div class="btn-group" mdbDropdownToggle>
        {{ itemsPerPage }}
        <mdb-icon fas icon="chevron-down" class="close"></mdb-icon>
      </div>
      <div class="dropdown-menu dropdown-primary">
        <a
          class="dropdown-item"
          *ngFor="let item of itemsPerPageOptions"
          (click)="onItemsPerPageSelected(item)"
        >
          {{ item }}
        </a>
      </div>
    </div>
    <label>per page</label>
    <div class="example-spacer"></div>
    <label
      >{{ pageBegin + 1 | number }} -
      {{ pageEnd > totalOrders ? totalOrders : (pageEnd | number) }}
      of
      {{ totalOrders | number }}
    </label>

    <button
      (click)="onPreviousPagePressed()"
      class="fas fa-chevron-left grey-text"
    ></button>
    <button
      (click)="onNextPagePressed()"
      class="fas fa-chevron-right grey-text"
    ></button>
  </div>
</ng-container>
<div style="height: 150px"></div>
